module.exports = "<div class=panel> <div class=panel-heading> <div class=panel-controls> <button type=button class=\"btn btn-info btn-sm btn-icon mr5\" ui-sref=\"hr.employees.item.availability({'employeeId': $ctrl.employeeId, 'availabilityId': ''})\"> <i class=\"fa fa-plus mr5\"></i><span translate>Add availability</span> </button> </div> </div> <div class=\"panel-body p15\"> <div class=calendar-viewer> <div ui-calendar=$ctrl.uiConfig.calendar class=fullcalendar calendar=employeeCalendar ng-model=$ctrl.eventSources></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/availability/availability.calendar.html
// module id = 440
// module chunks = 0